<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRedshiftDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="redshiftDelmodal = true"
            v-hasPermission="['monitor:redshiftMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:redshiftMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="redshiftDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ redshiftName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRedshift()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableRedshiftVue = {};
export default {
  name: "TableRedshift",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      redshiftDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      redshiftName: "",
      columns: [
        {
          title: this.$t("alarms.redshift.redshiftName"),
          key: "clusterIdentifier"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("ticket.list.status"),
          key: "clusterStatus"
        },
        {
          title: this.$t("alarms.instance.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableRedshiftDate: []
    };
  },
  beforeCreate: function() {
    tableRedshiftVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableRedshiftVue.companyId = val;
    });
    eventBus.$on("tag", function(val) {
      tableRedshiftVue.tag = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableRedshiftVue.getRedshiftData();
    },
    // 分页显示数据
    /****************************************************/
    getRedshiftData: function() {
      //列表分页
      this.$api.redshift
        .pageRedshift({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableRedshiftVue.companyId,
          tag: tableRedshiftVue.tag
        })
        .then(res => {
          this.tableRedshiftDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRedshiftVue.getRedshiftData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRedshiftVue.getRedshiftData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.redshiftName = this.tableRedshiftDate[index].accountName;
    },
    removeRedshift: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.redshift
        .deleteRedshift("id", this.tableRedshiftDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableRedshiftVue.getRedshiftData();
            this.isDisable = false;
            this.modal_loading = false;
            this.redshiftDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/redshiftDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.clusterIdentifier,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/redshift/TableRedshift.vue